module.exports = __webpack_public_path__ + "img/logo-fios.8cbfa8b2.png";